export const PAYMENT_HISTORY_MODAL_QUERY_PARAM = 'payment_history_modal';
